import { Component, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-new-post-install-load-dialog',
    template: `
      <div (keydown.enter)="saveLoadCase()">

        <form [formGroup]="newLoadForm">
            <label for="load-case-name">Load Case Name</label>
            <input class="w-full" id="load-case-name"  pInputText formControlName="name" autocomplete="off" />

            <div class="flex mt-4 space-x-2 justify-end">
              <p-button
                outlined="true"
                class="outlined-button"
                size="small"
                severity="danger"
                label="Cancel"
                icon="pi pi-times"
                (onClick)="closeDialog()"
              ></p-button>
              <p-button
                outlined="true"
                class="outlined-button"
                size="small"
                severity="success"
                label="Save"
                [disabled]="newLoadForm.invalid"
                icon="pi pi-check"
                (onClick)="saveLoadCase()"
              ></p-button>
            </div>

        </form>
        
      </div>
    `,
    styles: [],
    standalone: false
})
export class NewPostInstallLoadDialogComponent {

  public newLoadForm: UntypedFormGroup;

  @Output() saveLoad$ = new Subject<string>();
  @Output() cancelNewLoad$ = new Subject<boolean>();

  constructor(private _formBuilder: UntypedFormBuilder) {
      this.newLoadForm = this._formBuilder.group({
      name: ''
    });
  }

  closeDialog(): void {
    this.cancelNewLoad$.next(true);
  }

  saveLoadCase(): void {
    this.saveLoad$.next(this.newLoadForm.value.name.trim());
  }
}
